// src/utils/adminConfig.js
// Admin role configuration — owner email is hardcoded for security

export const OWNER_EMAIL = 'lucelias1212@gmail.com';
export const ADMIN_ROLES = ['owner', 'admin'];

export const isOwner = (email) => email?.toLowerCase() === OWNER_EMAIL;
export const isAdmin = (role) => ADMIN_ROLES.includes(role);
export const isOwnerRole = (role) => role === 'owner';
